/* eslint-disable react/jsx-fragments */
import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import Button from "@amzn/meridian/button";
import Modal, { ModalFooter } from "@amzn/meridian/modal";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import { useHistory } from "react-router-dom";
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import {getTaskById, updateTaskStatus} from "../../../apis/TaskApi";
import {ERROR_MSG_500, TASK_STATUS} from "../../../utils/Constants";
import useTaskStore from "../../../stores/TaskStore";
import {logOperationalMetric} from "../../../utils/Helper";

function StartTaskButton({ task, intl }) {
  const history = useHistory();
  let isLoading = false;
  /*********************
   *                   *
   *        hooks      *
   *                   *
   *********************/
  const updateTask = useTaskStore((state) => state.updateTask);
  const removeTask = useTaskStore((state) => state.removeTask);
  const [open, setOpen] = useState(false);

  /*********************
   *                   *
   *      handlers     *
   *                   *
   *********************/

  const onClickStart = useCallback(() => {
    const metricName = 'StartTask';
    logOperationalMetric(Date.now(), 'StartTaskButton', metricName, true, true);
    if (isLoading) return false;
    isLoading = true;
    getTaskById(task.id).then(res => {
      if (res.status === 200) {
        const {id, status} = res.data.task;
        if (status === TASK_STATUS.RESOLVED) {
          removeTask(id);
        } else {
          updateTask(id, res.data.task);
          if (status === TASK_STATUS.STARTED) {
            setOpen(true);
          } else {
            startTask();
          }
        }
      } else{
        alert(ERROR_MSG_500);
      }
    }).catch(err => {
      alert(ERROR_MSG_500);
    }).finally(() => {
      isLoading = false;
    })
  }, []);

  const onClose = useCallback(() => setOpen(false), []);

  const onConfirmRestart = useCallback(() => {
    startTask();
    setOpen(false);
  }, []);

  /*********************
   *                   *
   *        api        *
   *                   *
   *********************/

  const startTask = () => {
    updateTaskStatus(task.id, TASK_STATUS.STARTED).then(res => {
      if (res.status === 200) {
        history.push(`/task/${encodeURIComponent(task.id)}`);
      } else {
        alert(ERROR_MSG_500);
      }
    }).catch(err => {
      alert(ERROR_MSG_500);
    });
  }

  /*********************
   *                   *
   *      renderer     *
   *                   *
   *********************/

  return (
    <div onClick={event => event.stopPropagation()}>
      {!task.assignee ? (
        <Button onClick={onClickStart}>
          <FormattedMessage id="overview.taskTable.button.startTask" defaultMessage="Start Task" />
        </Button>
      ) : (
        <React.Fragment>
          <Button type="secondary" onClick={onClickStart}>
            <FormattedMessage id="overview.taskTable.button.restartTask" defaultMessage="Restart Task" />
          </Button>
          <Modal
            title={intl.formatMessage({id : "overview.warning.taskStartOverride", defaultMessage : "Warning: Task Start Override"})}
            open={open}
            onClose={onClose}
            scrollContainer="viewport"
            closeLabel="Close"
            describedById="modal-description"
          >
            <Text id="modal-description">
              <FormattedMessage id="overview.warning.taskStartOverrideMessage" defaultMessage="The task you are attempting to start has already been started. Are you sure you would like to continue?" />
            </Text>
            <ModalFooter>
              <Row alignmentHorizontal="right" widths="fit">
                <Button type="secondary" size="small" onClick={onClose}>
                  <FormattedMessage id="overview.taskTable.button.cancel" defaultMessage="Cancel" />
                </Button>
                <Button
                  type="primary"
                  size="small"
                  onClick={onConfirmRestart}
                >
                  <FormattedMessage id="overview.taskTable.button.confirm" defaultMessage="Confirm" />
                </Button>
              </Row>
            </ModalFooter>
          </Modal>
        </React.Fragment>
      )}
    </div>
  );
}

StartTaskButton.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.number,
    assignee: PropTypes.string,
    status : PropTypes.string
  }).isRequired,
  intl : intlShape.isRequired
};

export default injectIntl(StartTaskButton);


// WEBPACK FOOTER //
// ./src/components/overview/TaskTable/StartTaskButton.jsx